import type { OrderItem } from '@/lib/pos-types'

/**
 * Calcula totales para mostrar en UI (subtotal/IVA/total) a partir de items.
 *
 * Importante:
 * - El backend recalcula totales como fuente de verdad al guardar/cobrar.
 * - Este helper se usa para feedback inmediato en pantalla.
 */
export const computeOrderTotals = (items: OrderItem[], taxRate = 0.19) => {
  const total = items.reduce(
    (sum, i) =>
      i.status === 'cancelled'
        ? sum
        : sum + i.quantity * i.unitPrice,
    0,
  );

  const subtotal = Math.round(total / (1 + taxRate));
  const tax = total - subtotal;
  return { subtotal, tax, total }
}
